module.exports = __webpack_public_path__ + "components/flag/static/square/ua-d394c2aadef4da7918c349df2fd52109.svg";